<div class="prs-auth-modal-panel" data-testing-id="forgot-password-modal">
  <div class="modal-header">
    <h2 class="modal-title" id="prs-auth-modal-forgot-title">
      {{ 'account.forgotdata.password_retrieval.heading' | translate }}
    </h2>
    <button
      type="button"
      class="btn-close"
      [attr.title]="'dialog.close.text' | translate"
      [attr.aria-label]="'dialog.close.text' | translate"
      (click)="hide()"
    ></button>
  </div>

  <div class="modal-body">
    @if (success$ | async) {
    <p class="mb-3" role="status">{{ 'account.send_password.message' | translate }}</p>
    <button type="button" class="btn btn-primary" (click)="hide()">
      {{ 'dialog.close.text' | translate }}
    </button>
    } @else {
    <p
      class="text-muted mb-3"
      [ishServerHtml]="'account.forgotdata.password_retrieval_info.text' | translate"
    ></p>
    <ish-error-message [error]="error$ | async" [toast]="false" />

    <form novalidate [formGroup]="form" (ngSubmit)="submit()">
      <div class="form-group mb-3" [class.has-error]="invalidEmail()">
        <label class="form-label" for="prsForgotEmail">{{ 'account.forgotdata.email.label' | translate }}</label>
        <div class="prs-auth-input-wrap position-relative">
          <input
            id="prsForgotEmail"
            class="form-control"
            type="email"
            formControlName="email"
            autocomplete="email"
            [attr.aria-invalid]="invalidEmail() ? true : null"
          />
          <ish-auth-field-validation-icons [showError]="invalidEmail()" [showSuccess]="showValidEmail()" />
        </div>
        @if (invalidEmail()) {
        <div class="invalid-feedback d-block" role="alert">
          @if (form.controls.email.errors?.required) {
          {{ 'form.email.error.required' | translate }}
          } @else {
          {{ 'form.email.error.invalid' | translate }}
          }
        </div>
        }
      </div>

      <div class="d-flex flex-wrap gap-2 align-items-center">
        <button type="submit" class="btn btn-primary" [disabled]="(loading$ | async) || (form.invalid && form.touched)">
          {{ 'forgot_password.form.send.button.label' | translate }}
        </button>
        <button type="button" class="btn btn-link" (click)="hide()">
          {{ 'dialog.close.text' | translate }}
        </button>
      </div>
    </form>
    }
  </div>
</div>
